/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const RunButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="play-filter-button"
      buttonColor={colors.primaryColor}
      tooltip={formatMessage({ id: "common.run" })}
      iconName="play_arrow"
      css={labellessButtonCss}
      {...props}
    />
  );
};

export default RunButton;
